export type Products = Product[]

export interface Product {
  id: string
  name: string
  price?: number | null
  brand?: string
  category: string
  variant: string
  quantity?: number | null
}

export enum EcommerceEventName {
  ADD = 'add',
  PURCHASE = 'purchase',
  REMOVE = 'remove',
  DETAIL = 'detail',
}

export interface YmPropTypes {
  main: () => void
  city: () => void
}
